module.exports = __webpack_public_path__ + "static/media/portablewaterpump.1e7e27a3.jpg";